import styled from '@emotion/styled';

export const Caption = styled.p`
  margin: 0 auto;
  max-width: 44rem;
  color: ${({ theme }) => theme.colors.neutral.grey140};
  font-size: 0.875rem;
  line-height: 1.5;
  text-align: center;

  button {
    display: inline-block;
    margin: 0;
    padding: 0;
    border: 0;
    color: inherit;
    background-color: transparent;
    font: inherit;
    text-decoration: underline;
    cursor: pointer;

    &:hover {
      color: ${({ theme }) => theme.colors.neutral.grey160};
    }

    &:focus-visible {
      outline: 0.125rem dashed ${({ theme }) => theme.colors.brand.orange100};
      outline-offset: 0.25rem;
    }
  }
`;
